module.exports = __webpack_public_path__ + "static/img/mamma.38d8219.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mamma.jpg
// module id = aHN+
// module chunks = 1